// eslint-disable-next-line no-extra-semi
;(function () {
  return (module.exports = document.querySelector(
    '[http-equiv="X-UA-App-Name"]'
  )
    ? document
        .querySelector('[http-equiv="X-UA-App-Name"]')
        .getAttribute('content')
    : '')
})()
